import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onBeforeUnmount, onMounted, ref } from 'vue';
    import MainView from './views/MainView.vue';
    import { landPlotStore } from './store/modules/LandPLot';
    import { cardSettingsStore } from './store/modules/CardSettings';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

    const rootEl = ref<null | HTMLElement>(null);

    onMounted(() => {
        window.addEventListener('resize', () => {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        });

        cardSettingsStore.SET_MAP_DOM_RECT(
            rootEl.value!.getBoundingClientRect(),
        );

        if (rootEl.value) {
            window.addEventListener(
                'resize',
                () =>
                    rootEl.value &&
                    cardSettingsStore.SET_MAP_DOM_RECT(
                        rootEl.value.getBoundingClientRect(),
                    ),
            );
            window.addEventListener(
                'scroll',
                () =>
                    rootEl.value &&
                    cardSettingsStore.SET_MAP_DOM_RECT(
                        rootEl.value.getBoundingClientRect(),
                    ),
            );
        }

        window.addEventListener('clickFromTilda', () => {
            landPlotStore.SET_CURRENT_SECTION_ZONE('southwest');
        });
    });

    onBeforeUnmount(() => {
        window.removeEventListener('resize', () => {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        });

        window.removeEventListener(
            'resize',
            () =>
                rootEl.value &&
                cardSettingsStore.SET_MAP_DOM_RECT(
                    rootEl.value.getBoundingClientRect(),
                ),
        );
        window.removeEventListener(
            'scroll',
            () =>
                rootEl.value &&
                cardSettingsStore.SET_MAP_DOM_RECT(
                    rootEl.value.getBoundingClientRect(),
                ),
        );

        window.removeEventListener('clickFromTilda', () => {
            landPlotStore.SET_CURRENT_SECTION_ZONE('southwest');
        });
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "rootEl",
    ref: rootEl,
    class: "akinshino-map-select-app"
  }, [
    _createVNode(MainView)
  ], 512))
}
}

})